<template>
    <div class="MyCoupon">
        <el-tabs v-model="activeName" @tab-click="handleClick" v-show="show">
            <el-tab-pane :label="`未使用（${summary.unusecount}）`" name="first">
                <el-table :data="list1" v-if="list1.length" class="list1" style="width: 100%">
                    <el-table-column label="优惠券" class-name="coupon_value_box">
                        <template slot-scope="scope">
                            <div class="coupon_value">
                                <p class="value" v-if="scope.row.voucherdistype === 1"><span>￥</span>{{scope.row.faceprice}}</p>
                                <p class="value" v-if="scope.row.voucherdistype === 2">{{scope.row.voucherdisrate}}<span>折</span></p>
                                <p class="threshold">
                                    <span v-if="scope.row.userule === 1">无门槛</span>
                                    <span v-if="scope.row.userule === 0">满{{scope.row.minordermoney}}元可用</span>
                                </p>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="使用范围">
                        <template slot-scope="scope">
                            <div>
                                {{scope.row.usescopetype === 2 ? '指定商品可用' : '平台部分商品可用'}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="datetime" label="有效期限"></el-table-column>
                    <el-table-column label="操作" class-name="right">
                        <template slot-scope="scope">
                            <div class="handle">
                                <span @click="nowUse(scope.row)">立即使用</span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <page ref="page" :page="page1" v-if="list1.length" @currentChange="pageChange" />
                <div class="noData" v-if="!list1.length">
                    <img :src="require('@/common/images/gujing/null.png')" alt="">
                    <p>当前暂无未使用的优惠券</p>
                </div>
            </el-tab-pane>
            <el-tab-pane :label="`已使用（${summary.usecount}）`" name="second">
                <el-table :data="list2" class="list2" v-if="list2.length" style="width: 100%">
                    <el-table-column label="优惠券" class-name="coupon_value_box">
                        <template slot-scope="scope">
                            <div class="coupon_value">
                                <p class="value" v-if="scope.row.voucherdistype === 1"><span>￥</span>{{scope.row.faceprice}}</p>
                                <p class="value" v-if="scope.row.voucherdistype === 2">{{scope.row.voucherdisrate}}<span>折</span></p>
                                <p class="threshold">
                                    <span v-if="scope.row.userule === 1">无门槛</span>
                                    <span v-if="scope.row.userule === 0">满{{scope.row.minordermoney}}元可用</span>
                                </p>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="使用范围">
                        <template slot-scope="scope">
                            <div>
                                {{scope.row.usescopetype === 2 ? '指定商品可用' : '平台部分商品可用'}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="datetime" label="有效期限"></el-table-column>
                    <el-table-column class-name="right">
                        <!-- <template slot-scope="scope">
                            <div class="handle">
                                <span @click="nowUse(scope.row)">立即使用</span>
                            </div>
                        </template> -->
                    </el-table-column>
                </el-table>
                <page ref="page" :page="page2" v-if="list2.length" @currentChange="pageChange" />
                <div class="noData" v-if="!list2.length">
                    <img :src="require('@/common/images/gujing/null.png')" alt="">
                    <p>当前暂无已使用的优惠券</p>
                </div>
            </el-tab-pane>
            <el-tab-pane :label="`已过期（${summary.expirecount}）`" name="third">
                <el-table :data="list3" class="list3" v-if="list3.length" style="width: 100%">
                    <el-table-column label="优惠券" class-name="coupon_value_box">
                        <template slot-scope="scope">
                            <div class="coupon_value">
                                <p class="value" v-if="scope.row.voucherdistype === 1"><span>￥</span>{{scope.row.faceprice}}</p>
                                <p class="value" v-if="scope.row.voucherdistype === 2">{{scope.row.voucherdisrate}}<span>折</span></p>
                                <p class="threshold">
                                    <span v-if="scope.row.userule === 1">无门槛</span>
                                    <span v-if="scope.row.userule === 0">满{{scope.row.minordermoney}}元可用</span>
                                </p>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="使用范围">
                        <template slot-scope="scope">
                            <div>
                                {{scope.row.usescopetype === 2 ? '指定商品可用' : '平台部分商品可用'}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="datetime" label="有效期限"></el-table-column>
                    <el-table-column class-name="right">
                        <!-- <template slot-scope="scope">
                            <div class="handle">
                                <span @click="nowUse(scope.row)">立即使用</span>
                            </div>
                        </template> -->
                    </el-table-column>
                </el-table>
                <page ref="page" :page="page3" v-if="list3.length" @currentChange="pageChange" />
                <div class="noData" v-if="!list3.length">
                    <img :src="require('@/common/images/gujing/null.png')" alt="">
                    <p>当前暂无已过期的优惠券</p>
                </div>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>
<script>
import {getMyCoupongetinfo} from 'api/api'
import {mapActions, mapGetters} from 'vuex'
import page from '../../components/page3'
export default {
    data() {
        return {
            activeName: 'first',
            page1: {
                page: 1,
                pageSize: 5,
                total: 0
            },
            list1: [],
            page2: {
                page: 1,
                pageSize: 5,
                total: 0
            },
            list2: [],
            page3: {
                page: 1,
                pageSize: 5,
                total: 0
            },
            list3: [],
            summary: {},
            show: false
        }
    },
    created() {
        if (!this.user.isLogin) {
            this.setLoginPop(true)
        } else {
            this.getMyCoupongetinfo()
        }
    },
    methods: {
        handleClick() {
            console.log(this.activeName)
            if (this.activeName === 'first') {
                if (!this.list1.length) {
                    this.getMyCoupongetinfo()
                }
            } else if (this.activeName === 'second') {
                if (!this.list2.length) {
                    this.getMyCoupongetinfo()
                }
            } else if (this.activeName === 'third') {
                if (!this.list3.length) {
                    this.getMyCoupongetinfo()
                }
            }
        },
        // 立即使用
        nowUse(row) {
            this.$router.push({
                name: 'Search',
                query: {
                    couponinnerid: row.couponinnerid,
                    voucherdistype: row.voucherdistype
                }
            })
        },
        pageChange(page) {
            if (this.activeName === 'first') {
                this.page1.page = page.page
            } else if (this.activeName === 'second') {
                this.page2.page = page.page
            } else if (this.activeName === 'third') {
                this.page3.page = page.page
            }
            this.getMyCoupongetinfo()
        },
        getMyCoupongetinfo() {
            this.setLoading(true)
            const params = {
                status: 0,
                page: '',
                pageSize: 5
            }
            if (this.activeName === 'first') {
                params.page = this.page1.page
                params.status = 0
            } else if (this.activeName === 'second') {
                params.page = this.page2.page
                params.status = 10
            } else if (this.activeName === 'third') {
                params.page = this.page3.page
                params.status = 100
            }
            getMyCoupongetinfo({
                data: params,
                success: res => {
                    this.setLoading(false)
                    if (this.activeName === 'first') {
                        if (params.page === 1) {
                            this.summary = res.data.summary
                            this.page1.total = res.data.pageinfo.rowCount
                        }
                        this.list1 = res.data.content
                    } else if (this.activeName === 'second') {
                        if (params.page === 1) {
                            this.summary = res.data.summary
                            this.page2.total = res.data.pageinfo.rowCount
                        }
                        this.list2 = res.data.content
                    } else if (this.activeName === 'third') {
                        if (params.page === 1) {
                            this.summary = res.data.summary
                            this.page3.total = res.data.pageinfo.rowCount
                        }
                        this.list3 = res.data.content
                    }
                    this.show = true
                    console.log(res)
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        ...mapActions([
            'setLoading',
            'setLoginPop'
        ])
    },
    computed: {
        ...mapGetters([
            'user'
        ])
    },
    components: {
        page
    }
}
</script>
<style lang="scss">
    .MyCoupon {
        background: #FFFFFF;
        padding: 20px 30px;
        .list1, .list2, .list3 {
            .coupon_value_box {
                .coupon_value {
                    padding: 5px 22px;
                    background: #FEF6EF;
                    color: #FE666D;
                    border-radius: 10px;
                    text-align: center;
                    box-sizing: border-box;
                    width: 132px;
                    .value {
                        font-size: 28px;
                        line-height: 40px;
                        font-weight: bold;
                        span {
                            font-size: 16px;
                        }
                    }
                    .threshold {
                        font-size: 14px;
                    }
                }
            }
            .right {
                .cell {
                    text-align: right;
                    .handle {
                        span {
                            color: #409EFF;
                            font-size: 14px;
                            cursor: pointer;
                        }
                    }
                }
            }
        }
        .list3 {
            .coupon_value_box {
                .coupon_value {
                    background: #E5E5E5;
                    color: #999999;
                }
            }
        }
        .noData {
            padding: 88px 0 122px;
            text-align: center;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            img {
                margin-bottom: 20px;
                // width: 200px;
                height: 96px;
            }
            p {
                font-size: 14px;
                color: #CADAEE;
            }
        }
    }
</style>